import { render } from "./PartPrice.vue?vue&type=template&id=4be62a13"
import script from "./PartPrice.vue?vue&type=script&lang=js"
export * from "./PartPrice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__